module.exports = window["L"];